module.exports = __webpack_public_path__ + "static/media/ursina_badilatti.fd28923f.jpg";